
{
  "fr": {
    "configuratorLayerEditorStage": {
      "defaultText": "Votre texte ici"
    }
  }
}
